import { Tooltip } from "flowbite-react";
import { useMemo } from "react";
import { ImWarning } from "react-icons/im";
import { HiCheckCircle } from "react-icons/hi";
import { LeadType } from "../../../types/lead.type";

export default function PendenciesLead({ lead, placement }: { lead: Partial<LeadType>, placement?: 'right' | 'top' | 'bottom' | 'left' }) {

  const badgeColor = useMemo(() =>
    (lead.pendencies?.length === 0)
      ? 'bg-greenPrimary'
      : 'bg-yellowDark'
    , [lead.pendencies])

  return !lead.pendencies?.length ? (
    <div className="flex items-center justify-center"> <HiCheckCircle className={'text-greenPrimary h-6 w-6'} /> </div>
  ) : (
    <div className="flex items-center justify-center">
      <Tooltip content={(
        <ul>
          {lead.pendencies?.map(({ key, message }) =>
          (
            <li key={`key-${key}-${Date.now()}-${Math.random()}`} className="flex gap-1 items-center justify-start">
              <ImWarning className="text-yellowPrimary h-4 w-6" />
              <span> - {message}</span>
            </li>
          ))}
        </ul>
      )} placement={placement || 'right'} className={`bg-white text-black border`} trigger="click" arrow={true} >
        <button className={`rounded-full shadow-sm h-6 w-6 p-0 flex place-items-center place-content-center ${badgeColor}`}>
          {lead.pendencies?.length}
        </button>
      </Tooltip>
    </div>
  )
}